import { render, staticRenderFns } from "./Rolemanagement.vue?vue&type=template&id=24b0c4e7&scoped=true&"
import script from "./Rolemanagement.vue?vue&type=script&lang=js&"
export * from "./Rolemanagement.vue?vue&type=script&lang=js&"
import style0 from "./Rolemanagement.vue?vue&type=style&index=0&id=24b0c4e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b0c4e7",
  null
  
)

export default component.exports